var _ellipse, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelRedeemFailure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.0001,
    cy: 26.5,
    rx: 26.3058,
    ry: 26.5,
    fill: "#C62828",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2894 43.7075C36.6024 43.7075 44.1521 36.1021 44.1521 26.7203C44.1521 17.3386 36.6024 9.73315 27.2894 9.73315C17.9764 9.73315 10.4268 17.3386 10.4268 26.7203C10.4268 36.1021 17.9764 43.7075 27.2894 43.7075Z",
    fill: "#C62828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.798 22.1963L31.6932 34.0915C32.494 34.8923 33.7923 34.8923 34.593 34.0915C35.3938 33.2908 35.3938 31.9924 34.593 31.1917L22.6979 19.2965C21.8971 18.4957 20.5988 18.4957 19.798 19.2965C18.9973 20.0973 18.9973 21.3956 19.798 22.1963Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6988 34.0953L34.594 22.2002C35.3948 21.3994 35.3948 20.1011 34.594 19.3003C33.7933 18.4996 32.495 18.4996 31.6942 19.3003L19.799 31.1955C18.9982 31.9963 18.9982 33.2946 19.799 34.0953C20.5998 34.8961 21.8981 34.8961 22.6988 34.0953Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelRedeemFailure);
export default __webpack_public_path__ + "static/media/CancelRedeemFailure.2cb9df453f24c089426a0a18233a298f.svg";
export { ForwardRef as ReactComponent };